import { Action } from '@ngrx/store';
import { Company } from '../models/company.model';

export enum ActionTypes {
    FETCH_COMPANIES         = '[Company API] Fetch Companies',
    FETCH_COMPANIES_FAILURE = '[Company API] Fetch Companies Failure',
    FETCH_COMPANIES_SUCCESS = '[Company API] Fetch Companies Success',
    ADD_COMPANY             = '[Company Page] Add Company',
    CLEAR_COMPANIES         = '[Company Page] Clear Companies',
    SELECT_COMPANY          = '[Company Page] Select Company',
    SELECT_COMPANY_V2       = '[Company Page] Select CompanyV2',
}

export class FetchCompanies implements Action {
    readonly type: string  = ActionTypes.FETCH_COMPANIES;

    constructor(public payload?: any) {}
}

export class FetchCompaniesFailure implements Action {
    readonly type: string = ActionTypes.FETCH_COMPANIES_FAILURE;

    constructor(public payload?: any) {}
}

export class AddCompany implements Action {
    readonly type: string = ActionTypes.ADD_COMPANY;

    constructor(public payload: Company) {}
}

export class FetchCompaniesSuccess implements Action {
    readonly type: string = ActionTypes.FETCH_COMPANIES_SUCCESS;

    constructor(public payload: Company[]) {}
}

export class SelectCompany implements Action {
    readonly type: string = ActionTypes.SELECT_COMPANY;

    constructor(public payload: string) {}
}

export class SelectCompanyV2 implements Action {
  readonly type: string = ActionTypes.SELECT_COMPANY_V2;

  constructor(public payload: string) {}
}


export class ClearCompanies implements Action {
    readonly type: string = ActionTypes.CLEAR_COMPANIES;

    constructor(public payload?: any) {}
}

export type Actions =
    | FetchCompanies
    | FetchCompaniesFailure
    | FetchCompaniesSuccess
    | AddCompany
    | SelectCompany
    | ClearCompanies;
